// @flow
import type { PaymentState } from './index'
import type {RootState} from '../../state'
import OrderItemPaymentConfiguration from '../../../types/order-item-payment-configuration'

export default {
  paymentMethods: (state: PaymentState, getters: Object, rootState: RootState, rootGetters: Object) => {
    return state.paymentMethodsOrder
      ? state.paymentMethodsOrder.paymentMethods
        .filter(paymentMethod => rootGetters['shop/paymentMethods'].includes(paymentMethod.title))
      : []
  },
  paymentConfigurations: (state: PaymentState): { [string]: OrderItemPaymentConfiguration } => {
    return state.paymentMethodsOrder ? state.paymentMethodsOrder.orderItemPaymentConfigurations : {}
  },
  selectedPaymentMethod: (state: PaymentState) => {
    return state.selectedPaymentMethod
  },
  selectedPaymentOption: (state: PaymentState) => {
    return state.selectedPaymentOption
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/payment/getters.js